export const PortfolioUpdateEnum = {
  TECH_AREAS_WITH_COURSES: '/portfolio-update/regional-areas/with-courses',
  AVAILABLE_TECH_AREAS: '/portfolio-update/regional-areas/available',
  CREATE_REGIONAL_AREA: '/portfolio-update/regional-areas',
  DELETE_REGIONAL_AREA: '/portfolio-update/regional-areas/{regionalAreaId}',
  AREA_ID: '/portfolio-update/regional-areas/{regionalAreaId}',
  AREA_ID_COURSES: '/portfolio-update/courses/regionalArea/{regionalAreaId}',
  SAVE_STATUS_COURSES:
    '/portfolio-update/courses/status/regionalArea/{regionalAreaId}',
  SAVE_COURSES_IN_TECH_AREA:
    '/portfolio-update/course-versions/import-or-update',
  COURSES_BY_TYPE_AND_VERSION_ID:
    '/portfolio-update/courses/area/{areaId}/version/{versionId}',
  COURSES_BY_TYPE_AND_REGIONAL_AREA_ID:
    '/portfolio-update/courses/regionalArea/{regionalAreaId}/available',
  CHANGE_STATUS: '/portfolio-update/courses/{courseVersionId}/status',
  COURSE_VERSION_PUBLISH: 'portfolio-update/courses/{courseVersionId}/publish',
  COURSE_VERSIONS_BY_STATUS:
    '/portfolio-update/courses/regional-area/{regionalAreaId}/by-status',
  COURSE_VERSION_DETAILS: '/portfolio-update/courses/by-group-and-order',
  COURSE_VERSION_DELETE: '/portfolio-update/courses/{courseVersionId}',
  COURSE_VERSION_DEPRECATION_EXPIRATION:
    '/portfolio-update/courses/{courseVersionId}/deprecation-expiration',
  REGIONAL_AREA_COMMITTEE:
    '/portfolio-update/regional-areas/{regionalAreaId}/committee',
  AREAS_CNAE_REGIONAL_AREA_ID:
    '/portfolio-update/cnae-list/regional-area/{regionalAreaId}',
}
